
















































































import Vue from 'vue';
import { BROADCAST } from '@/mass/models/Broadcast';
import massVuex from '../../vuex/common';

export default Vue.extend({
  mixins: [massVuex],
  computed: {
    messageTypeContent() {
      let text = '';
      if (this.broadcast.interactType === BROADCAST.INTERACT_TYPE.TEXT) {
        text = '文字';
      } else if (this.broadcast.interactType === BROADCAST.INTERACT_TYPE.IMAGE) {
        text = '图片';
      } else if (this.broadcast.interactType === BROADCAST.INTERACT_TYPE.VOICE) {
        text = '语音';
      } else {
        text = '所有类型';
      }
      return text;
    },
    isMessage(): boolean {
      return BROADCAST.INTERACT_TYPE.MESSAGE === this.broadcast.interactType || BROADCAST.INTERACT_TYPE.TEXT === this.broadcast.interactType || BROADCAST.INTERACT_TYPE.IMAGE === this.broadcast.interactType || BROADCAST.INTERACT_TYPE.VOICE === this.broadcast.interactType;
    },
  },
  data() {
    return {
      BROADCAST,
      showMessageList: false,
      messageSetHeight: 30,
      hoverItem: null,
    };
  },
  methods: {
    updateInteractTypeIsAll(interactTypeIsAll: number) {
      this.$store.commit('UPDATE_INTERACT_TYPE_IS_ALL', interactTypeIsAll);
      if (interactTypeIsAll === BROADCAST.INTERACT_TYPE_ALL.ON) {
        this.$store.commit('UPDATE_INTERACT_TYPE', BROADCAST.INTERACT_TYPE.ALL);
      } else {
        this.$store.commit('UPDATE_INTERACT_TYPE', BROADCAST.INTERACT_TYPE.NONE);
      }
    },
    updateInteractType(interactType: number) {
      this.$store.commit('UPDATE_INTERACT_TYPE', interactType);
      this.showMessageList = false;
    },
  },
});
